// import React, { useContext, useEffect, useState } from "react";
// import styles from "./MaflamInstructors.module.css";
// import { LanguageContext } from "../../Component/LanguageContext/LanguageContext";
// import axios from "axios";
// import { Link } from "react-router-dom";
// const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
// const MaflamInstructors = () => {
//   const { direction } = useContext(LanguageContext);
//   const [instructors, setInstructors] = useState([]);
//   const [fetchError, setFetchError] = useState(null);

//   useEffect(() => {
//     const fetchInstructors = async () => {
//       try {
//         const response = await axios.get(
//           `${marketingBackendUrl}/maflam/instructors`
//         );

//         setInstructors(response.data);
//       } catch (err) {
//         console.error("Failed to fetch instructors:", err);
//         setFetchError("Failed to fetch instructors");
//       }
//     };

//     fetchInstructors();
//   }, []);

//   if (fetchError) {
//     return <p>Error loading instructors: {fetchError}</p>;
//   }

//   return (
//     <div className={styles.instructorsContainerss}>
//       <div className={styles.instructorsContainer}>
//         <h2 style={{ fontSize: "36px" }}>
//           {direction === "rtl" ? "المدربون" : "Instructors"}
//         </h2>
//         <div className={styles.instructorsGrid}>
//           {instructors.map((instructor, index) => (
//             <div key={index} className={styles.instructorCard}>
//               <img
//                 src={instructor.instructorImageUrl}
//                 alt={
//                   direction === "rtl"
//                     ? instructor.instructorNameArab
//                     : instructor.instructorNameEng
//                 }
//                 className={styles.instructorImage}
//               />
//               <p>
//                 <Link to="#">
//                   {direction === "rtl"
//                     ? instructor.instructorNameArab
//                     : instructor.instructorNameEng}
//                 </Link>
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MaflamInstructors;


//this has to be uncommented
import React, { useContext, useEffect, useState } from "react";
import styles from "./MaflamInstructors.module.css";
import { LanguageContext } from "../LanguageContext/LanguageContext";
import axios from "axios";
import { Link } from "react-router-dom";

const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;

const MaflamInstructors = () => {
  const { direction } = useContext(LanguageContext);
  const [instructors, setInstructors] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [selectedInstructor, setSelectedInstructor] = useState(null);

  useEffect(() => {
    const fetchInstructors = async () => {
      try {
        const response = await axios.get(
          `${marketingBackendUrl}/maflam/instructorsPop`
          // `${marketingBackendUrl}/maflam/instructors`
        );
        console.log(response);

        setInstructors(response.data);
      } catch (err) {
        console.error("Failed to fetch instructors:", err);
        setFetchError("Failed to fetch instructors");
      }
    };

    fetchInstructors();
  }, []);

  if (fetchError) {
    return <p>Error loading instructors: {fetchError}</p>;
  }

  return (
    <div className={styles.instructorsContainerss}>
      <div className={styles.instructorsContainer}>
        <h2 style={{ fontSize: "36px" }}>
          {direction === "rtl" ? "المدربون" : "Instructors"}
        </h2>
        <div className={styles.instructorsGrid}>
          {instructors.map((instructor, index) => (
            <div
              key={index}
              className={styles.instructorCard}
              onClick={() => setSelectedInstructor(instructor)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={instructor.instructorImageUrl}
                alt={
                  direction === "rtl"
                    ? instructor.instructorNameArab
                    : instructor.instructorNameEng
                }
                className={styles.instructorImage}
              />
              <p>
                <Link to="#">
                  {direction === "rtl"
                    ? instructor.instructorNameArab
                    : instructor.instructorNameEng}
                </Link>
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Popup Modal */}
      {selectedInstructor && (
        <div className={styles.modalOverlay}>
          <div
            style={{
              background: `linear-gradient(0deg, rgba(10, 23, 31, 0.70) 0%, rgba(10, 23, 31, 0.70) 100%), url(${selectedInstructor.instructorImageUrl}) lightgray 50% / cover no-repeat`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            className={styles.modalContent}
            dir={direction}
          >
            <div className={styles.modalGrid}>
              <div className={styles.modalText}>
                <div className={styles.modalText}>
                  <button
                    className={`${styles.closeButton} ${
                      direction === "rtl" ? styles.rtl : styles.ltr
                    }`}
                    onClick={() => setSelectedInstructor(null)}
                  >
                    &times;
                  </button>
                </div>
                <div className={styles.header}>
                  <h5 className={styles.toggle}>
                    {direction === "rtl" ? "عن المدرب" : "About the Instructor"}
                  </h5>
                  <hr className={styles.line} />
                </div>
                <h2 className="styles.instructorName">
                  {direction === "rtl"
                    ? selectedInstructor.instructorNameArab
                    : selectedInstructor.instructorNameEng}
                </h2>
                <div className="styles.paragraph">
                  {direction === "rtl"
                    ? selectedInstructor.instructorDescriptionArab
                    : selectedInstructor.instructorDescriptionEng}
                </div>
                <a href={selectedInstructor.redirectLink}>
                <button
  className={styles.modalButton}
  style={{
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "17px",
    color: "var(--Primary-Primary-400, #061C2B)",
  }}
>
  {direction === "rtl" ? "اكتشف دورات المدرب" : "Explore Courses"}
                </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaflamInstructors;
